export enum CommentStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED'
}
